import { createFileRoute } from "@tanstack/react-router";

import CompetitionScoringForm from "@/components/CompetitionProfile/CompetitionScoringForm";

const Component = () => {
  const { competitionUuid } = Route.useParams();
  return <CompetitionScoringForm competitionUuid={competitionUuid} />;
};

export const Route = createFileRoute("/gym/$venueUuid/events/$competitionUuid/profile/scoring")({
  component: Component,
});
